import React from 'react';
import PropTypes from 'prop-types';

import styles from './index.module.scss';

const StaticMap = ({ title, mapLocation, zoom = 17, className }) => (
	<div className={`${styles.staticMap} ${className || ''}`}>
		<iframe
			loading='lazy'
			className={styles.staticMap_Embed}
			title={title}
			src={`https://www.google.com/maps/embed/v1/place?key=${process.env.GATSBY_GOOGLE_MAPS_API_KEY}&q=${mapLocation?.replace('&', '%26')}&zoom=${zoom}`}
		/>
	</div>
);

StaticMap.propTypes = {
	title: PropTypes.string.isRequired,
	mapLocation: PropTypes.string.isRequired,
	zoom: PropTypes.number,
	className: PropTypes.string,
};

export default StaticMap;
